// @flow
// Try to avoid as much as possible
const dangerouslySetReduxFormValue = ({
  field,
  value,
  options,
}: {
  field: string,
  value: string | boolean,
  options?: Object, // eslint-disable-line flowtype/no-weak-types
}) => ({
  type: "redux-form/CHANGE",
  form: "reservation",
  field,
  value,
  ...options,
})

export default dangerouslySetReduxFormValue
